import { useCallback, useRef } from 'react'

export function useScrollShadow() {
  const cleanupRef = useRef<(() => void) | null>(null)

  const handleScrollRef = useCallback((el: HTMLDivElement | null) => {
    // Clean up previous listener
    if (cleanupRef.current) {
      cleanupRef.current()
      cleanupRef.current = null
    }

    if (!el) return
    
    const parent = el.parentElement
    if (!parent) return

    const handleScroll = () => {
      if (parent.scrollTop > 0) {
        el.classList.add('shadow-md')
      } else {
        el.classList.remove('shadow-md')
      }
    }

    parent.addEventListener('scroll', handleScroll)
    // Initial check
    handleScroll()

    // Store cleanup function
    cleanupRef.current = () => parent.removeEventListener('scroll', handleScroll)
  }, [])

  return handleScrollRef
}

// Kept for backward compatibility - but prefer using useScrollShadow hook
export function handleOnScrollSearch(el: HTMLDivElement | null) {
  if (!el) return
  const parent = el.parentElement
  if (!parent) return

  const handleScroll = () => {
    if (parent.scrollTop > 0) {
      el.classList.add('shadow-md')
    } else {
      el.classList.remove('shadow-md')
    }
  }

  parent.addEventListener('scroll', handleScroll)
  // Initial check
  handleScroll()

  // Don't return cleanup function - this was causing React warning
}
